import * as React from 'react';
import Api, { GraphqlQuery } from 'requestapijs';
import { activeWorkQuery } from './constant';
import { UserConsumer } from '../Common/UserContext';
import { Row, Col, Loading, notify, Button, Card } from 'sha-el-design/lib';
import { Link } from 'react-router-dom';
import { WorkCompletionStatus } from './WorkCompletionStatus';
import {
  WorkHistoryNodeConnection, WorkHistoryCall, WorkHistoryNode, CallStatusEnum,
  WorkHistoryMutationInput, CallHistoryMutationInput, CallResponseMutationInput, DndMutationInput,
} from '../../../schema';
import { RetailerCallDetail } from './RetailerCallDetail';
import { Inject, fromGlobalId, toGlobalId } from '../../helpers';
import { WorkHIstoryService } from '../../service/workHistoryService';
import { nestedAccess } from 'sha-el-design/lib/helpers';
import { CallHIstoryService } from '../../service/callHistoryService';
import { Response } from '../Call/Response';
import * as moment from 'moment';
import { EMAIL_REPORT_API_URL, HEADER } from '../../config';
import { DndService } from '../../service/dndService';

export class ActiveWork extends React.Component<{}, State> {
  @Inject workHistoryService: WorkHIstoryService;
  @Inject callHistoryService: CallHIstoryService;
  @Inject dndService: DndService;

  constructor(props) {
    super(props);
    this.state = {
      updateCount: 0,
      activeCall: null,
      isAnswerSubmitDisabled: false,
      isDndButtonDisabled: false,
      isHoldButtonDisabled: false,
      isFinishWorkDisabled: false,
      isLoading: false,
      isEditRetailerDisabled: true,
    };
  }

  addCallHistory(callHistory: CallHistoryMutationInput, onSucess = (r) => null) {
    this.callHistoryService.add(
      callHistory,
      onSucess,
      () => true,
    );
  }

  onWrongAnswer = (
    workHistoryNode: WorkHistoryNode, activeCall: WorkHistoryCall, secondNumber: boolean, toCloseRetailer: string,
  ) => {
    this.updateWorkHistoryWhenNotConnected(
      workHistoryNode, activeCall, secondNumber, CallStatusEnum.WRONG_NUMBER, toCloseRetailer,
    );
  }

  onNoAnswer = (workHistoryNode: WorkHistoryNode, activeCall: WorkHistoryCall, secondNumber: boolean) => {
    this.updateWorkHistoryWhenNotConnected(workHistoryNode, activeCall, secondNumber, CallStatusEnum.NO_REPLY);
  }

  onAnswer = (workHistoryNode: WorkHistoryNode, activeCall: WorkHistoryCall, secondNumber: boolean) => {
    this.setState({
      activeCall: { workHistoryNode, activeCall: {...activeCall, callStatus: CallStatusEnum.ANSWERED }, secondNumber },
      isEditRetailerDisabled: false,
    });
  }

  onReject = (workHistoryNode: WorkHistoryNode, activeCall: WorkHistoryCall) => {
    const index = workHistoryNode.calls.findIndex((v) => v.retailer.id === activeCall.retailer.id);
    const nextNoAnswerIndex = this.findNextNoReply(index, workHistoryNode);
    const deleteCount = nextNoAnswerIndex <= 0 ? 1 : (nextNoAnswerIndex - index);
    const deletedWorkHistoryCall = workHistoryNode.calls.splice(index, deleteCount);
    deletedWorkHistoryCall[0] && (deletedWorkHistoryCall[0] = {
      ...deletedWorkHistoryCall[0],
      ...activeCall,
      callStatus: CallStatusEnum.REJECTED,
    });
    workHistoryNode.calls.push(...deletedWorkHistoryCall);

    const workHistoryInput: WorkHistoryMutationInput = {
      id: workHistoryNode.id,
      startDateTime: workHistoryNode.startDateTime,
      endDateTime: workHistoryNode.endDateTime,
      calls: (workHistoryNode.calls.map((v) => JSON.stringify({
        retailer_id: fromGlobalId(v.retailer.id),
        call_status: v.callStatus,
        mobile_number: v.mobileNumber,
        attempts: v.attempts,
      }))) as any,
      work: workHistoryNode.work.id,
      town: nestedAccess(workHistoryNode.town, 'id'),
      area: nestedAccess(workHistoryNode.area, 'id'),
    };

    this.workHistoryService.add(
      workHistoryInput,
      () => this.setState(
        { updateCount: this.state.updateCount + 1, isEditRetailerDisabled: true },
      ),
      () => notify({
        type: 'error',
        title: 'Something went wrong',
        duration: 3000,
      }),
    );
  }

  updateWorkHistoryWhenNotConnected = (
    workHistoryNode: WorkHistoryNode, activeCall: WorkHistoryCall,
    secondNumber: boolean, callStatus: CallStatusEnum, toCloseRetailer = 'No',
  ) => {
    let pushToCalls = false;
    let deletedWorkHistoryCall: WorkHistoryCall[] = [];
    if (secondNumber || !activeCall.retailer.mobilenumber2) {
      const index = workHistoryNode.calls.findIndex((v) => v.retailer.id === activeCall.retailer.id);
      const nextNoAnswerIndex = this.findNextNoReply(index, workHistoryNode);
      const deleteCount = nextNoAnswerIndex === -1 ? 1 : (nextNoAnswerIndex - index);
      deletedWorkHistoryCall = workHistoryNode.calls.splice(index, deleteCount);
      pushToCalls = true;
    }
    activeCall.callStatus = callStatus;
    activeCall.attempts = (activeCall.attempts || 0) + 1;
    const mobileNumber = secondNumber ? activeCall.retailer.mobilenumber2 : activeCall.retailer.mobilenumber1;
    if (pushToCalls) {
      deletedWorkHistoryCall[0] && (deletedWorkHistoryCall[0] = {
        ...deletedWorkHistoryCall[0],
        ...activeCall,
        mobileNumber,
      });
      workHistoryNode.calls.push(...deletedWorkHistoryCall);
    }

    // PERF-01: send only THIS retailer's outcome instead of re-POSTing the
    // whole queue. Payload is now constant-size rather than proportional to
    // the town's retailer count, and the server applies the identical
    // splice-and-push rotation under a row lock -- so two tabs can no longer
    // silently overwrite each other's outcomes with a stale full snapshot.
    //
    // incrementAttempts is TRUE: the local `activeCall.attempts` bump above is
    // optimistic UI only and never leaves the browser, so the server must
    // increment its own stored value. Both land on N+1.
    this.workHistoryService.updateCall(
      {
        workHistory: workHistoryNode.id,
        retailerId: Number(fromGlobalId(activeCall.retailer.id)),
        callStatus,
        mobileNumber,
        incrementAttempts: true,
      },
      () => this.setState(
        {
          updateCount: this.state.updateCount + 1,
          activeCall: {
            workHistoryNode,
            activeCall,
            secondNumber,
          },
          isEditRetailerDisabled: true,
        },
        () => this.addCallHistory({
          callStart: moment().format(),
          callEnd: moment().format(),
          mobileNumber,
          callStatus,
          workHistory: workHistoryNode.id,
          retailer: activeCall.retailer.id,
          toCloseRetailer,
        }),
      ),
      () => notify({
        type: 'error',
        title: 'Something went wrong',
        duration: 3000,
      }),
    );
  }

  disableAnswerSubmitButton = () => {
    this.setState({ isAnswerSubmitDisabled: true });
  }

  onAnswerSubmit = (
    callResponse: CallResponseMutationInput, callHistory: CallHistoryMutationInput, toCloseRetailer = 'No',
  ) => {
    const { activeCall } = this.state;
    const mobileNumber = activeCall.secondNumber
      ? activeCall.activeCall.retailer.mobilenumber2 : activeCall.activeCall.retailer.mobilenumber1;
    this.addCallHistory({
      ...callHistory,
      mobileNumber,
      retailer: activeCall.activeCall.retailer.id,
      workHistory: activeCall.workHistoryNode.id,
      toCloseRetailer,
    },
      (response) => {
        this.callHistoryService.addCallResponse(
          {
            ...callResponse, workHistory: activeCall.workHistoryNode.id,
            call: toGlobalId(`CallHistoryNode:${response.id}`),
          },
          () => notify({
            type: 'success',
            title: 'Call Saved',
            callBack: () => {
              this.updateWorkHistory(CallStatusEnum.ANSWERED);
              this.setState({ isAnswerSubmitDisabled: false });
            },
          }),
          () => notify({
            type: 'error',
            title: 'Something sent wrong',
            callBack: () => this.setState({ isAnswerSubmitDisabled: false }),
          }),
        );
      },
    );
  }

  findNextNoReply = (index: number, workHistoryNode: WorkHistoryNode) => {
    let nextNoAnswerIndex = -1;
    const retailerNotCalled = workHistoryNode.calls.find((call, i) => !call.callStatus && i > index);
    if (!retailerNotCalled) {
      nextNoAnswerIndex = workHistoryNode.calls.findIndex((v, i) =>
        (v.callStatus === CallStatusEnum.NO_REPLY) && (i > index),
      );
      nextNoAnswerIndex = nextNoAnswerIndex === -1 ? index : nextNoAnswerIndex;
    }
    return nextNoAnswerIndex;
  }

  updateWorkHistory = (callStatus) => {
    const { activeCall: { activeCall, workHistoryNode, secondNumber } } = this.state;
    const index = workHistoryNode.calls.findIndex((v) => v.retailer.id === activeCall.retailer.id);
    const nextNoAnswerIndex = this.findNextNoReply(index, workHistoryNode);
    const deleteCount = nextNoAnswerIndex === -1 ? 1 : (nextNoAnswerIndex - index);
    const deletedWorkHistoryCall = workHistoryNode.calls.splice(index, deleteCount);
    activeCall.callStatus = CallStatusEnum.ANSWERED;
    const mobileNumber = secondNumber ? activeCall.retailer.mobilenumber2 : activeCall.retailer.mobilenumber1;
    deletedWorkHistoryCall[0] && (deletedWorkHistoryCall[0] = {
      ...deletedWorkHistoryCall[0],
      ...activeCall,
      mobileNumber,
      callStatus,
    });
    workHistoryNode.calls.push(...deletedWorkHistoryCall);

    // PERF-01: same single-entry patch as the not-connected path. attempts is
    // NOT incremented here -- an answered call was never counted as a retry --
    // and the server preserves the stored value when incrementAttempts is false.
    this.workHistoryService.updateCall(
      {
        workHistory: workHistoryNode.id,
        retailerId: Number(fromGlobalId(activeCall.retailer.id)),
        callStatus,
        mobileNumber,
        incrementAttempts: false,
      },
      () => this.setState({ activeCall: null, updateCount: this.state.updateCount + 1, isEditRetailerDisabled: true }),
      () => notify({
        type: 'error',
        title: 'Could not save the call outcome',
        message: 'The response was recorded but the queue was not updated. Please refresh.',
        duration: 4000,
      }),
    );
  }

  finishWork = (workHistory: WorkHistoryNode) => {
    this.setState({ isFinishWorkDisabled: true });
    const workHistoryInput: WorkHistoryMutationInput = {
      id: workHistory.id,
      startDateTime: workHistory.startDateTime,
      endDateTime: moment().format(),
      calls: (workHistory.calls.map((v) => JSON.stringify({
        retailer_id: fromGlobalId(v.retailer.id),
        call_status: v.callStatus,
        mobile_number: v.mobileNumber,
        attempts: v.attempts,
      }))) as any,
      work: workHistory.work.id,
      town: nestedAccess(workHistory.town, 'id'),
      area: nestedAccess(workHistory.area, 'id'),
      isActive: false,
    };

    // The report email used to be fired BEFORE the finishing mutation, so the
    // report was rendered from the pre-finish state (no end_date_time, stale
    // final outcome). It now fires only after the finish has actually landed,
    // and the redirect waits for the email request to settle either way -- an
    // email failure must never strand the caller on a finished work. (The old
    // code also read response.error/.message off a body the server never
    // shapes that way, so the toast text was garbage.)
    this.workHistoryService.add(
      workHistoryInput,
      () => {
        const done = () => {
          this.setState({ isFinishWorkDisabled: false });
          location.href = '/dashboard/start_calling/';
        };
        Api.get(`${EMAIL_REPORT_API_URL}/${workHistory.id}`, HEADER)
          .subscribe(done, done);
      },
      () => {
        this.setState({ isFinishWorkDisabled: false });
        notify({
          type: 'error',
          title: 'Could not finish work',
          message: 'The work was not marked finished. Please try again.',
          duration: 4000,
        });
      },
    );
  }

  putWorkOnHold = (workHistory: WorkHistoryNode) => {
    this.setState({ isHoldButtonDisabled: true });
    const workHistoryInput: WorkHistoryMutationInput = {
      id: workHistory.id,
      startDateTime: workHistory.startDateTime,
      calls: (workHistory.calls.map((v) => JSON.stringify({
        retailer_id: fromGlobalId(v.retailer.id),
        call_status: v.callStatus,
        mobile_number: v.mobileNumber,
        attempts: v.attempts,
      }))) as any,
      work: workHistory.work.id,
      town: nestedAccess(workHistory.town, 'id'),
      area: nestedAccess(workHistory.area, 'id'),
      onHold: true,
      isActive: false,
    };

    this.workHistoryService.add(
      workHistoryInput,
      () => {
        this.setState({ isHoldButtonDisabled: false });
        location.href = '/dashboard/start_calling/';
      },
      () => {
        this.setState({ isHoldButtonDisabled: false });
      },
    );
  }

  addToDnd = () => {
    if (!this.state.activeCall) {
      return notify({
        type: 'error',
        title: 'No Call Active',
      });
    }
    this.setState({ isDndButtonDisabled: true });

    const input: DndMutationInput = {
      phonenumber: this.state.activeCall.activeCall.retailer.mobilenumber1,
      createdat: moment().format(),
    };

    const input2: DndMutationInput = {
      phonenumber: this.state.activeCall.activeCall.retailer.mobilenumber2,
      createdat: moment().format(),
    };

    [input, input2].map(
      (v) => this.dndService.add(
        v,
        () => notify({
          type: 'success',
          title: 'added retailers number for dnd',
          callBack: () => this.setState({ isDndButtonDisabled: false }),
        }),
        () => notify({
          type: 'error',
          title: 'Something went wrong',
          callBack: () => this.setState({ isDndButtonDisabled: false }),
        }),
      ),
    );
  }

  render() {
    const {
      updateCount,
      activeCall,
      isAnswerSubmitDisabled,
      isDndButtonDisabled,
      isHoldButtonDisabled,
      isFinishWorkDisabled,
      isEditRetailerDisabled,
    } = this.state;

    return (
      // <Loading
      //   isLoading={isLoading}
      //   render={() => (
          <div>
            <Button
              onClick={this.addToDnd}
              type='secondary'
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
              }}
              disabled={isDndButtonDisabled}
            >
              Add to DND
            </Button>
            <UserConsumer>
              {({ id: userId }) => (
                <GraphqlQuery
                  queryString={activeWorkQuery}
                  variables={{ caller: userId, updateCount }}
                  render={
                    (response: { allWorkHistory: WorkHistoryNodeConnection }, error, loading) => {
                      // BUG-03: this render used to dereference
                      // response.allWorkHistory.edges[0].node in 13 places with
                      // no guard. Landing here with no active work -- a stale
                      // "Continue Work" link, a bookmark, a refresh after
                      // Finish Work, a second tab -- threw and white-screened
                      // the whole app. Resolve the node ONCE and render a real
                      // empty state when there is none.
                      const edges = nestedAccess(response, 'allWorkHistory', 'edges') || [];
                      const node: WorkHistoryNode = edges.length ? edges[0].node : null;
                      return (
                        <Loading
                          isLoading={loading}
                          render={() => (
                            node ? (
                            <Row>
                              <Col span={16}>
                                <RetailerCallDetail
                                  work={node}
                                  onAnswer={(call, secondNumber) =>
                                    this.onAnswer(node, call, secondNumber)}
                                  onNoAnswer={(call, secondNumber) =>
                                    this.onNoAnswer(node, call, secondNumber)}
                                  onWrongNumber={(call, secondNumber, toCloseRetailer) =>
                                    this.onWrongAnswer(node, call, secondNumber, toCloseRetailer)}
                                  onReject={(call) => this.onReject(node, call)}
                                  toggleLoading={(hasLoading) => this.setState({ isLoading: hasLoading })}
                                  isEditRetailerDisabled={isEditRetailerDisabled}
                                />
                              </Col>
                              <Col span={8}>
                                <WorkCompletionStatus
                                  work={node}
                                  finishWork={() => this.finishWork(node)}
                                  setToOnHold={() => this.putWorkOnHold(node)}
                                  isHoldButtonDisabled={isHoldButtonDisabled}
                                  isFinishWorkDisabled={isFinishWorkDisabled}
                                />
                              </Col>
                              {nestedAccess(activeCall, 'activeCall', 'callStatus') === CallStatusEnum.ANSWERED  && <Col
                                span={24}
                              >
                                <Response
                                  town={nestedAccess(node, 'area', 'townid', 'id')
                                    || nestedAccess(node, 'town', 'id')}
                                  state={node.area
                                    ? node.area.townid.districtid.stateid.id
                                    : node.town.districtid.stateid.id}
                                  onSubmit={this.onAnswerSubmit}
                                  isAnswerSubmitDisabled={isAnswerSubmitDisabled}
                                  disableAnswerSubmitButton={this.disableAnswerSubmitButton}
                                />
                              </Col>}
                            </Row>
                            ) : (
                            <Row>
                              <Col span={24}>
                                <Card>
                                  <div style={{ textAlign: 'center', padding: '48px 20px' }}>
                                    <h3 style={{ margin: '0 0 8px' }}>
                                      {error ? 'Could not load your active work' : 'No active work'}
                                    </h3>
                                    <p style={{ margin: '0 0 20px', color: '#666' }}>
                                      {error
                                        ? 'Something went wrong while loading. Please try again.'
                                        : 'You have no work in progress. Start or resume one from the work list.'}
                                    </p>
                                    <Link to='/dashboard/start_calling/'>
                                      <Button type='primary'>Go to Work List</Button>
                                    </Link>
                                  </div>
                                </Card>
                              </Col>
                            </Row>
                            )
                          )}
                        />
                      );
                    }
                  }
                />
              )}
            </UserConsumer>
          </div>
      //   )}
      // />
    );
  }
}

interface State {
  updateCount: number;
  activeCall: {
    workHistoryNode: WorkHistoryNode;
    activeCall: WorkHistoryCall;
    secondNumber: boolean;
  };
  isAnswerSubmitDisabled: boolean;
  isDndButtonDisabled: boolean;
  isHoldButtonDisabled: boolean;
  isFinishWorkDisabled: boolean;
  isLoading: boolean;
  isEditRetailerDisabled: boolean;
}
